<template>
  <div>
    <vue-headful title="Mijn profiel" />
    <Header page_title="Mijn profiel" />
    <div class="px-4 mx-2 pb-4">
      <div class="container-fluid px-0 pb-1 mb-2">
        <form @change="onFormChange" @submit.prevent="onSubmit">
          <NotificationContainer />
          <div>
            <p>
              <strong>?</strong>
            </p>
          </div>
          <button
            type="submit"
            class="btn btn-warning btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >
            Opslaan
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      user: "",
      professionList: [],
      industryList: [],
      form: {
        search_profession_id: "",
        search_degree_id: "",
        show_experience: null
      },
      required: "",
      available: null,
      availability: {},
      experiences: [],
      education: []
    };
  },
  props: ["action"],
  async created() {},
  async mounted() {
    await this.fetchData();
    // TODO
    // var scroll_height = document.body.clientHeight;
    // var device_height = window.innerHeight;
    // var max_height = (150 / 100) * device_height;
    // if (scroll_height > max_height) {
    //   set fixed footer here
    // }
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      this.required = this.$store.state.applicant_fields;
      // update the form obj from user
      for (var obj in this.form) {
        if (this.user[obj]) {
          this.form[obj] = this.user[obj];
        }
      }

      // API information
      // this.industryList = await this.getAPIList("industries");
      // this.professionList = await this.getAPIList("professions");
      await this.autoFillForm();

      this.$store.state.loading = false;
    },
    async autoFillForm() {
      return new Promise(resolve => {
        if (localStorage.getItem("applicant-profile")) {
          // other profile details NOT YET saved
          const profile = JSON.parse(localStorage.getItem("applicant-profile"));
          for (var obj in profile) {
            if (profile[obj]) {
              this.form[obj] = profile[obj]; // update
            }
          }
          this.form.show_experience = this.form.show_experience ? true : false;
          this.onFormChange();
        }
        if (!localStorage.getItem("applicant-profile")) {
          this.form.show_experience = this.user.show_experience ? true : false;
        }
        this.available = this.user.search_available;
        if (this.user.search_availability) {
          var dates = JSON.parse(this.user.search_availability);
          this.availability = Object.assign({}, this.availability, {
            dates: dates,
            count: dates.length
          });
        }
        this.experiences = this.user.experiences;
        this.education = this.user.educations;
        resolve();
      });
    },
    async updateUser() {
      // console.log("async updateUser()");
      return new Promise((resolve, reject) => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/applicant";

        if (!localStorage.getItem("applicant-profile")) {
          this.form.show_experience = this.user.show_experience ? true : false;
        } else {
          this.form.show_experience = this.form.show_experience ? true : false;
        }

        let formData = new FormData();
        for (var obj in this.form) {
          if (obj == "show_experience") {
            formData.append(obj, this.form[obj] ? 1 : 0);
          } else {
            formData.append(obj, this.form[obj]);
          }
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(success => {
            localStorage.removeItem("form-pending");
            localStorage.removeItem("applicant-profile");
            const notification = {
              type: "success",
              message: success.data.message
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            resolve();
          })
          .catch(error => {
            const notification = {
              type: "danger",
              message: error.response.data
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            reject();
          });
      });
    },
    async onSubmit() {
      // console.log("async onSubmit()");
      this.$store.state.loading = true;
      window.scrollTo(0, 0);
      await this.updateUser();
      // continue only if resolve()
      await this.updateLocalUser();
      // console.log(this.action);
      // if (this.action == "next") {
      this.$router.replace({
        name: "applicant-profile"
      });
      // }
      this.$store.state.loading = false;
    },
    onFormChange() {
      localStorage.setItem("applicant-profile", JSON.stringify(this.form));
      localStorage.setItem("form-pending", JSON.stringify(true));
      // console.log("onFormChange()");
    }
  },
  beforeRouteLeave(to, from, next) {
    // remove the form-pending if accessing sub page
    var subpages = [
      "salary-details",
      "location",
      "availability",
      "work-add",
      "edit-work",
      "education-add",
      "edit-education"
    ];
    if (subpages.indexOf(to.name) > -1) {
      localStorage.removeItem("form-pending");
      next({ replace: true });
    } else {
      this.savePending(to, from, next);
    }
  },
  components: {}
};
</script>

<style scoped>
.ellipsis.salary {
  max-width: calc(100% - 125px);
}
.ellipsis.address {
  max-width: calc(100% - 60px);
}
.ellipsis.availability {
  max-width: calc(100% - 100px);
}
</style>
